import { render, staticRenderFns } from "./CurrencyInput.vue?vue&type=template&id=27dd6602&"
import script from "./CurrencyInput.vue?vue&type=script&lang=ts&"
export * from "./CurrencyInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports